export default __webpack_public_path__ + "static/media/cover.0b20e905.jpg";